export default __webpack_public_path__ + "static/media/more-desserts.e9627e72.png";